var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgShowIco = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "show"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C40.3567 0 47.5578 15.64 47.8493 16.303C48.0502 16.7463 48.0502 17.2537 47.8493 17.697C47.5578 18.36 40.3567 34 24 34C7.64328 34 0.442205 18.36 0.150733 17.697C-0.0502443 17.2537 -0.0502443 16.7463 0.150733 16.303C0.442205 15.64 7.64328 0 24 0ZM3.63125 17C5.14005 19.856 11.7067 30.6 24 30.6C36.2933 30.6 42.86 19.856 44.3687 17C42.86 14.144 36.2933 3.4 24 3.4C11.7067 3.4 5.14005 14.144 3.63125 17Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7129 17.0008C13.7129 11.3675 18.3186 6.80078 24.0001 6.80078C29.6816 6.80078 34.2874 11.3675 34.2874 17.0008C34.2874 22.6341 29.6816 27.2008 24.0001 27.2008C18.3186 27.2008 13.7129 22.6341 13.7129 17.0008ZM17.142 17.0008C17.142 20.7563 20.2125 23.8008 24.0001 23.8008C25.819 23.8008 27.5634 23.0844 28.8496 21.8091C30.1357 20.5339 30.8583 18.8043 30.8583 17.0008C30.8583 13.2452 27.7878 10.2008 24.0001 10.2008C20.2125 10.2008 17.142 13.2452 17.142 17.0008Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShowIco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/showIco.f50e68b07583d98daccf1c700303b4da.svg";